<template>
  <div>
    <v-container class="white text-center">
      <v-row>
        <v-col cols="12" class="body-2 grey--text text-left pb-0">
          <div>
            <v-breadcrumbs :items="routeItems" divider=">"></v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <v-row class="pa-2">
        <v-col cols="12" class="headline pl-5">PEDIDOS</v-col>
      </v-row>
    </v-container>
    <v-container class="background-gray pt-0">
      <v-row justify="space-between" height="10">
        <v-col cols="6" sm="4" class="pt-0 pb-0 pr-0">
          <v-overflow-btn
            append-icon="arrow_drop_down"
            class="combo pa-0 caption"
            v-model="orderType"
            height="25"
            dense
            :items="menuOrderTypeArray"
            @change="changeTypeOrder(orderType)"
          ></v-overflow-btn>
        </v-col>
        <v-col cols="6" sm="4" class="pt-0 pb-0 pl-0">
          <v-overflow-btn
            append-icon="arrow_drop_down"
            class="combo pa-0 caption"
            color="accent"
            v-model="filterBy"
            dense
            height="25"
            :items="[
              { text: 'Fecha-Asc', value: 'dateAsc' },
              { text: 'Fecha-Desc', value: 'dateDesc' },
              { text: 'Número-Asc', value: 'numAsc' },
              { text: 'Número-Desc', value: 'numDesc' }
            ]"
            @change="filterByParam(filterBy)"
          ></v-overflow-btn>
        </v-col>
      </v-row>
      <v-row wrap class="mt-2 pl-5 pr-5">
        <v-col
          cols="12"
          md="6"
          lg="4"
          class="pb-0"
          v-for="(pedido, index) in pedidos"
          :key="index"
        >
          <v-card class="elevation-0" outlined>
            <v-container class="pa-0 pl-2 pr-2">
              <v-row align="center">
                <v-col cols="7" class="pt-1 pb-1">
                  <span class="body-2 font-weight-regular"
                    >Nº Pedido: {{ pedido.saleOrderID }}</span
                  >

                  <br />
                  <span class="body-2 font-weight-regular"
                    >Nº Orden: {{ pedido.id }}</span
                  >

                  <br />
                  <div class="caption font-weight-light fix-marign-middle">
                    Fecha Inicio:{{ pedido.date | compactDate }}
                  </div>
                  <br />
                  <div
                    :class="statusClass(pedido.status)"
                    class="font-weight-light fix-marign"
                  >
                    Realizar Checklist
                  </div>
                </v-col>
                <v-col cols="5" class="text-right" justify="center">
                  <v-btn
                    class="black--text"
                    small
                    block
                    color="accent"
                    @click="
                      $router.push({
                        name: 'search',
                        params: {
                          orderNumber: pedido.id,
                          orderType: 'order'
                        }
                      })
                    "
                    >Ver Detalles</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-col cols="12" class="text-center">
          <v-progress-circular
            v-show="loadingMoreOrders"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-col>
        <v-col v-if="!pedidos.length" cols="12" class="text-center"
          >No se han encontrado pedidos en esa categoría</v-col
        >
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { shortDateNumbersStringFilter } from "@/filters";
import { errorMessage } from "@/services/MessageService";
import { loaderDone } from "@/services/LoaderService";

export default {
  data() {
    return {
      orderType: { text: "", value: "" },
      filterBy: { text: "Fecha - Asc", value: "dateAsc" },
      currentOrdersShownPage: 1,
      maxOrdersPerPage: 10,
      loadingMoreOrders: false
    };
  },
  beforeMount() {
    this.getAccesSections(this.userAccess);
  },
  async mounted() {
    try {
      if (this.$route.params.filter) {
        let totalOrders = await this.obtenerPedidos({
          orderType: this.$route.params.filter
        });
        switch (this.$route.params.filter) {
          case "delivery":
            this.orderType = {
              text: "Entregas",
              value: this.$route.params.filter
            };
            break;
          case "maintenance":
            this.orderType = {
              text: "Mantenimiento",
              value: this.$route.params.filter
            };
            break;
          case "recollection":
            this.orderType = {
              text: "Recolecciones",
              value: this.$route.params.filter
            };
            break;
          case "relocation":
            this.orderType = {
              text: "Reubicación",
              value: this.$route.params.filter
            };
            break;
          case "rented-service":
            this.orderType = {
              text: "Rentado Servicio",
              value: this.$route.params.filter
            };
            break;
          default:
            break;
        }
        while (totalOrders < 5) {
          totalOrders += await this.obtenerPedidos({
            orderType: this.$route.params.filter,
            lastDocument: this.lastDocument
          });
        }
        loaderDone();
      }
    } catch (error) {
      errorMessage("Ha ocurrido un error inesperado en los pedidos");
    }
  },
  created() {
    // :: Create a listener when the user scroll the page down
    // :: to call the next orders in list.
    window.addEventListener("scroll", this.lazyLoad);
  },
  beforeDestroy() {
    loaderDone();
  },
  destroyed() {
    // :: Destroy the listener when the user scroll the page down
    // :: to deactivate this listener in other views.
    window.removeEventListener("scroll", this.lazyLoad);
  },
  computed: {
    ...mapState("dashboard", ["menuOrderTypeArray"]),
    ...mapState("user", ["userAccess"]),
    ...mapState("orders", ["pedidos", "totalResults", "lastDocument"]),
    routeItems() {
      let routeItems = [];
      let path = "";
      this.$router.currentRoute.fullPath.split("/").forEach(element => {
        path += element + "/";
        routeItems.push({
          text:
            element.length > 0
              ? element.charAt(0).toUpperCase() + element.substring(1)
              : "Inicio",
          disabled: false,
          href: path
        });
        if (routeItems[routeItems.length - 1].text === "Inicio")
          routeItems.splice(-1, 1);
      });
      return routeItems;
    }
  },
  methods: {
    ...mapActions("dashboard", ["getAccesSections"]),
    ...mapActions("orders", [
      "obtenerPedidos",
      "filterDateAsc",
      "filterDateDesc",
      "filterNumAsc",
      "filterNumDesc"
    ]),
    statusClass(status) {
      let color = status == "pickup" ? "orange" : "red";
      return "caption " + color + "--text";
    },
    filterByParam(filter) {
      switch (filter) {
        case "dateAsc":
          this.filterDateAsc();
          break;
        case "dateDesc":
          this.filterDateDesc();
          break;
        case "numAsc":
          this.filterNumAsc();
          break;
        case "numDesc":
          this.filterNumDesc();
          break;
        default:
          break;
      }
    },
    async lazyLoad() {
      // :: Create a variable to know when the scroll position is at the bottom of the page.
      const scrollIsAtTheBottom =
        Math.abs(
          document.documentElement.scrollHeight -
            window.innerHeight -
            window.scrollY
        ) <= 1;

      if (scrollIsAtTheBottom) {
        await this.obtenerPedidos({
          orderType: this.$route.params.filter,
          lastDocument: this.lastDocument
        });
        loaderDone();
      }
    },
    async changeTypeOrder(orderType) {
      await this.obtenerPedidos({ orderType });
      loaderDone();
    }
  },
  filters: {
    compactDate: shortDateNumbersStringFilter
  }
};
</script>
<style>
.combo {
  font-weight: 400;
}
.caption {
  font-weight: 300;
}
.combo i.v-icon.notranslate.material-icons.theme--light {
  color: #ffcd00 !important;
}
.fix-marign {
  margin-top: -27px !important;
}
.fix-marign-middle {
  margin-top: -3px !important;
}

/* Style Overflow buttons */
.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: unset;
}
.v-overflow-btn .v-input__control::before {
  height: 0px;
}
.v-overflow-btn .v-select__selection--comma:first-child {
  margin-left: 6px;
}
</style>
